import { render, staticRenderFns } from "./BetaSchools.vue?vue&type=template&id=b3ececbe&"
import script from "./BetaSchools.vue?vue&type=script&lang=js&"
export * from "./BetaSchools.vue?vue&type=script&lang=js&"
import style0 from "./BetaSchools.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports